import { render, staticRenderFns } from "./TestFilterTag.vue?vue&type=template&id=62ef6373&scoped=true&"
import script from "./TestFilterTag.vue?vue&type=script&lang=js&"
export * from "./TestFilterTag.vue?vue&type=script&lang=js&"
import style0 from "./TestFilterTag.vue?vue&type=style&index=0&id=62ef6373&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef6373",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
